import {
    Component,
    OnDestroy,
    OnInit,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { FooterComponent } from "@components/footer/footer.component";
import { MapTabWidgetComponent } from "@components/map/components/widgets/map-tab-widget/map-tab-widget.component";
import { MapWidgetTabComponent } from "@components/map/components/widgets/map-tab-widget/map-widget-tab/map-widget-tab.component";
import { TranslatePipe } from "@ngx-translate/core";
import { Subject } from "rxjs";
import { AuthenticationService } from "~app/common/services/authentication/authentication.service";
import { EventService } from "~app/common/services/cqs/event.service";
import { TplFilterComponent } from "./components/tpl-filter/tpl-filter.component";
import { TplHandelserComponent } from "./components/tpl-handelser/tpl-handelser.component";
import { TplHanteraAoComponent } from "./components/tpl-hantera-ao/tpl-hantera-ao.component";
import { TplKartaComponent } from "./components/tpl-karta/tpl-karta.component";
import { TplOmdestineraComponent } from "./components/tpl-omdestinera/tpl-omdestinera.component";
import { TplSearchComponent } from "./components/tpl-search/tpl-search.component";
import { TplTransporttilldelningComponent } from "./components/tpl-transporttilldelning/tpl-transporttilldelning.component";
import { TplTabOpenMessage } from "./events/TplTabOpenMessage";
import { TplTabId } from "./state/state-models";
import { TplStateService } from "./state/tpl-state.service";

@Component({
    selector: "rask-transportplanera",
    templateUrl: "./transportplanera.component.html",
    styleUrls: ["./transportplanera.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        MapTabWidgetComponent,
        MapWidgetTabComponent,
        TplSearchComponent,
        TplFilterComponent,
        TplTransporttilldelningComponent,
        TplOmdestineraComponent,
        TplHanteraAoComponent,
        TplHandelserComponent,
        TplKartaComponent,
        FooterComponent,
        TranslatePipe
    ]
})

export class TransportplaneraComponent implements OnInit, OnDestroy {
    dirtyHandelser: number = null;
    openTab: string;
    tabIds = TplTabId;

    private readonly authenticationService = inject(AuthenticationService);
    private readonly eventService = inject(EventService);
    private readonly ngUnsubscribe$ = new Subject<void>();
    private readonly stateService = inject(TplStateService);

    canEdit = () => this.authenticationService.canEdit();

    dirtychanged($event: number) {
        this.dirtyHandelser = $event;
    }

    hasSearchResult(): boolean {
        return this.stateService.current && this.stateService.current.getArbetsordrar().length > 0;
    }

    ngOnDestroy(): void {
        this.stateService.clear();
        this.ngUnsubscribe$.next();
        this.ngUnsubscribe$.complete();
    }

    ngOnInit() {
        this.onOpen("search");
    }

    onOpen($event: string) {
        this.openTab = $event;
        const event = new TplTabOpenMessage(this.openTab);
        this.eventService.emit(event);
        this.stateService.select($event);
    }
}
